
import Vue from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Button from '@/components/Button/index.vue';
import Input from '@/components/Input/index.vue';
import getBycar from '@/services/territory/get-territory-by-car';
import fetchTerritoryData from '@/services/territory-access/get-territory-car';
import getTerritoryImgByCar from '@/services/territory/get-territory-img';
import carExist from '@/services/territory-access/get-territory-car-exist';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';

export default Vue.extend({
  components: {
    Button,
    Input,
    ValidationObserver,
    ValidationProvider,
  },
  inject: ['userLogged', 'getStepDate', 'resetStepsRegisterTerritory'],
  data() {
    return {
      isLoading: false,
      carStatusResponse: {} as any,
      loadingButtonCheckCar: false,
      isCarUsed: false,
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        condigo: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      },
    };
  },
  computed: {
    carValueFormated(): string {
      return this.getStepDate.territory.car.trim().replaceAll('-', '');
    },
  },
  methods: {
    async onCheckCar() {
      this.loadingButtonCheckCar = true;
      const { stDocument } = this.userLogged;

      this.carStatusResponse = await fetchTerritoryData(this.carValueFormated);
      if (!this.carStatusResponse || this.carStatusResponse.hasErrors) {
        this.$toast('CAR inserido não existe');
        this.loadingButtonCheckCar = false;
        return;
      }

      const INITIALS_STATE_MATO_GROSSO = 'MT';

      if (this.carStatusResponse.dadosExtratoPdf.estado !== INITIALS_STATE_MATO_GROSSO) {
        this.$toast('CAR inserido não é do estado do MT');
        this.loadingButtonCheckCar = false;
        return;
      }

      const response = await getBycar(stDocument, this.carValueFormated);

      if (response.hasErrors) {
        this.reset();
      }

      const isExistCar = response?.some((territory: any) => {
        return territory.agents.some((agent: any) => agent.document === stDocument);
      });

      if (isExistCar) {
        this.$toast('Você já possui esse CAR');
        this.loadingButtonCheckCar = false;
        return;
      }

      this.getStepDate.territory.geometry = this.carStatusResponse.geom;
      this.getStepDate.territory.codCounty = this.carStatusResponse.codigoMunicipio;
      getTerritoryImgByCar(this.getStepDate.territory.geometry)
        .then((url: any) => {
          this.getStepDate.img.url = url;
          this.getStepDate.img.isImgHidden = false;
        })
        .catch(() => {
          this.getStepDate.img.retry = true;
        });

      await this.verifyCarExist();
    },
    async verifyCarExist() {
      const MESSAGE_NOT_EXIST_CAR_BOND = 'O CAR não está vinculado a ninguém.';
      const response = await carExist(this.getStepDate.territory.car);
      await this.getTerritoryByCarCode(this.getStepDate.territory.car);
      if (this.carStatusResponse.dadosExtratoPdf.statusImovel !== 'Ativo' && this.carStatusResponse.dadosExtratoPdf.statusImovel !== 'Pendente') {
        this.$toast('Atualmente o Cadastro Ambiental Rural informado se encontra inapto a ser cadastrado. Consulte o status no SICAR e regularize a situação para prosseguir no programa.');
        this.loadingButtonCheckCar = false;
        return;
      }

      if (!MESSAGE_NOT_EXIST_CAR_BOND.includes(response.message)) {
        this.isCarUsed = true;
        return;
      }

      await this.onNextStep();
      this.loadingButtonCheckCar = false;
    },
    onPrevStep() {
      this.isCarUsed = false;
      this.getStepDate.territory.car = '';
      this.getStepDate.territory.name = '';
      this.reset();
    },
    async onNextStep() {
      this.getStepDate.currentStep += 1;
      this.isCarUsed = false;
      this.getStepDate.refs.car.reset();
      this.loadingButtonCheckCar = false;
    },
    reset() {
      this.loadingButtonCheckCar = false;
      this.getStepDate.refs.car.reset();
      this.resetStepsRegisterTerritory();
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);
      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;
      this.territoryByCar.loaded = true;
    },
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getStepDate.refs.car = this.$refs.car;
  },
});
